import CoreRoot from "./IdentityRoot.vue"
export default CoreRoot
